module.exports = __webpack_public_path__ + "img/order.1fb76a75.png";